import React from 'react';

import { getLayoutClass } from '../utils';

type TProps = {
  layout: string;
};

export function SkeletonTemplate1({ layout }: TProps) {
  return (
    <>
      <section className={getLayoutClass(layout)} data-testid="skeleton ">
        <div className="vitrine-template1__skeleton">
          <div className="vitrine-template1__skeleton--header">
            <span />
            <span />
            <span />
          </div>

          <div className="vitrine-template1__skeleton--title" />
          <div className="vitrine-template1__skeleton--description">
            <span />
            <span />
          </div>
          <div className="vitrine-template1__skeleton--button">
            <span />
          </div>
          <div className="vitrine-template1__skeleton--banner">
            <div className="vitrine-template1__skeleton--banner-header">
              <span />
              <span />
              <span />
            </div>
            <span />
            <span />
          </div>
          <div className="vitrine-template1__skeleton--slider">
            <div className="vitrine-template1__skeleton--slider-buttons">
              <span />
              <span />
            </div>
            <div className="vitrine-template1__skeleton--cards">
              {['1', '2', '3', '4', '5', '6'].map(value => (
                <div key={value} className="vitrine-template1__skeleton--card">
                  <div className="vitrine-template1__skeleton--card--line" />
                  <div className="vitrine-template1__skeleton--card--line" />
                  <div className="vitrine-template1__skeleton--card--line" />
                </div>
              ))}
            </div>
          </div>
          <div className="vitrine-template1__skeleton--moreinfo" />
          <div className="vitrine-template1__skeleton--rules" />
        </div>
      </section>
    </>
  );
}
